
export enum AlertDismissExplanation {
  Unknown = 1,
  Requested = 2,
  Unexpected = 3
}
